<template>
  <b-container fluid style="max-width:1200px;">
    <b-row style="margin-top: 4em">
      <b-col>
        <h2 class="text-secondary">
          {{ $t("globals.all_inquiries") }}
          <icon v-if="getAllInquiriesLoading" name="spinner" spin></icon>
        </h2>
      </b-col>
      <b-col>
        <b-btn
          class="float-right m-1"
          variant="success"
          size="sm"
          :to="{name: 'newinquiry'}"
        >
          {{ $t("globals.new_inquiry") }}
        </b-btn>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="my-3">
        <b-input-group>
          <b-input-group-prepend>
            <b-form-select v-model="forYear" :options="yearOptions" />
          </b-input-group-prepend>
          <b-form-input
            v-model="filter"
            :placeholder="$t('globals.type_to_search')"
          />
          <b-input-group-append>
            <b-btn variant="warning" :disabled="!filter" @click="filter = ''">
              {{ $t("globals.clear") }}
            </b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col sm="2" class="my-3">
        <b-input-group>
          <!-- customer source search -->
          <b-input-group-prepend>
            <b-form-select
              v-model="customerSource"
              :options="customerSourceOptions"
              :placeholder="$t('globals.source')"
            />
          </b-input-group-prepend>
        </b-input-group>
      </b-col>
      <b-col cols="2" class="my-3">
        <b-form-select v-model="perPage" :options="perPageOptions" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          primary-key="id"
          :hover="getUserBrandPermissions.inquiry_show"
          small
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter="filter"
          :current-page="currentPage"
          :per-page="perPage"
          :items="getAllInquiries"
          :fields="fields"
          @row-clicked="rowClicked"
          @filtered="currentPage = 1"
        >
          <!-- Created at -->
          <template v-slot:cell(created_at)="row">
            <div v-b-tooltip.hover :title="row.item.created_at">
              {{ row.item.created_at.substring(0, 10) }}
            </div>
          </template>
          <!-- Status -->
          <template v-slot:cell(status)="row">
            <b-badge :variant='row.item._rowVariant'>
              {{ $t('globals.' + row.item.status) }}
            </b-badge>
          </template>
          <!-- Customer -->
          <template v-slot:cell(customer)="row">
            <div v-if="row.item.customer">
              <router-link
                style="color:#17a2b8"
                :to="{name: 'customer', params:{ id: row.item.customer.id }}"
              >
                <i>{{ row.item.customer.company_name }}</i>
              </router-link>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          :total-rows="getAllInquiries.length"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import "vue-awesome/icons/spinner";

export default {
  components: {
    Icon: () => import("vue-awesome/components/Icon.vue")
  },
  data() {
    var yearOptions = [];
    var currentYear = new Date().getFullYear();

    // Current year until 2018
    for (var i = currentYear; i >= 2018; i--) {
      yearOptions.push(i.toString());
    }

    return {
      forYear: currentYear.toString(),
      yearOptions: yearOptions,
      sortBy: "creation_date",
      sortDesc: true,
      filter: null,
      currentPage: 1,
      perPage: 20,
      customerSourceOptions: [ { text: this.$t('globals.all_sources'), value: 'all' } ],
      customerSource: 'all',
      perPageOptions: [
        { text: "20 " + this.$t("globals.per_page"), value: 20 },
        { text: "40 " + this.$t("globals.per_page"), value: 40 },
        { text: "60 " + this.$t("globals.per_page"), value: 60 }
      ],
      fields: [
        {
          key: "agent.full_name",
          label: this.$t("globals.agent"),
          sortable: true
        },
        {
          key: "customer",
          label: this.$t("globals.customer"),
          sortable: true
        },
        {
          key: "status",
          label: this.$t("globals.status"),
          sortable: true
        },
        {
          key: "created_at",
          label: this.$t("globals.creation_date"),
          sortable: true
        }
      ],
      items: []
    };
  },
  methods: {
    ...mapActions("inquiries", ["fetchAllInquiries"]),
    ...mapActions("constants", ["fetchActiveEnums"]),
    rowClicked(item) {
      this.$router.push({ name: "inquiry", params: { id: item.id } });
    },
    callFetchEnums() {
      this.customerSourceOptions = [{ text: this.$t('globals.all_sources'), value: 'all' }]
      this.fetchActiveEnums({this_ref: this, enums: ["customer_source"]})
        .then((res) => {
          if (res) {
            this.customerSourceOptions = this.customerSourceOptions.concat(res.customer_source);
          }
        })
    },
  },
  computed: {
    ...mapGetters("inquiries", ["getAllInquiries", "getAllInquiriesLoading"]),
    ...mapGetters(["getUserBrandPermissions"])
  },
  created() {
    if (!this.getUserBrandPermissions.inquiries_index) {
      this.$router.push({ name: "dashboard" });
    }
  },
  watch: {
    forYear: function(new_date_from) {
      this.fetchAllInquiries({ year: new_date_from, source: this.customerSource });
    },
    customerSource: function(new_customer_source) {
      this.fetchAllInquiries({ year: this.forYear, source: new_customer_source });
    }
  },
  mounted() {
    this.callFetchEnums();
    this.fetchAllInquiries({ year: this.forYear, source: this.customerSource });
  }
};
</script>
